import { isNil } from 'ramda';
import { DEFAULT_VALUE } from './optionalValue';
export const humanBoolean = (value, trueValue = 'Yes', falseValue = 'No') => (value ? trueValue : falseValue);
export const optionalHumanBoolean = (value, defaultValue = DEFAULT_VALUE, trueValue = 'Yes', falseValue = 'No') => (isNil(value) ? defaultValue : humanBoolean(value, trueValue, falseValue));
